import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { mockData } from '../data/mockData';

const FAQSection = () => {
  return (
    <section id="faq" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
              Frequently Asked Questions
            </h2>
            <div className="w-24 h-1 bg-amber-500 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600">
              Everything you need to know about trademark registration in the United States.
            </p>
          </div>

          <Accordion type="single" collapsible className="space-y-4">
            {mockData.faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-gray-50 rounded-lg px-6 border border-gray-200 hover:border-amber-500 transition-colors"
              >
                <AccordionTrigger className="text-left text-lg font-semibold text-blue-900 hover:text-amber-600 py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-700 leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-12 bg-gradient-to-r from-blue-50 to-amber-50 rounded-xl p-8 text-center border border-blue-200">
            <h3 className="text-2xl font-bold text-blue-900 mb-3">
              Still Have Questions?
            </h3>
            <p className="text-gray-700 mb-4">
              Our trademark experts are here to help. Contact us for a free consultation and get all your questions answered.
            </p>
            <p className="text-lg font-semibold text-blue-900">
              Call us at <a href={`tel:${mockData.contact.phone}`} className="text-amber-600 hover:text-amber-700">{mockData.contact.phone}</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
